import { inject, Injectable, signal } from '@angular/core';
import { REGISTRATION_ID } from 'src/app/@constants/local-storage-key-constants';
import { MixpanelService } from 'src/app/@services/mixpanel.service';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from 'src/app/@utils/local-storage-util';

const state = {
  registrationId: signal<string>(''),
};

@Injectable({
  providedIn: 'root',
})
export class ExternalRegistrationStateService {
  constructor() {
    this._initializeRegistrationId();
  }

  private readonly _mixpanelService = inject(MixpanelService);

  public readonly $registrationId = state.registrationId.asReadonly();

  setRegistrationId(registrationId: string | null): void {
    const validId = registrationId?.trim() || null;
    state.registrationId.set(validId ?? '');

    if (validId) {
      setLocalStorageItem(REGISTRATION_ID, validId);
      this._mixpanelService.setRegistrationId(validId);
    } else {
      setLocalStorageItem(REGISTRATION_ID, '');
      this._mixpanelService.setRegistrationId(null);
    }
  }

  reset(): void {
    state.registrationId.set('');
    removeLocalStorageItem(REGISTRATION_ID);
  }

  private _initializeRegistrationId(): void {
    const storedRegistrationId = getLocalStorageItem<string>(REGISTRATION_ID);
    if (storedRegistrationId) {
      state.registrationId.set(storedRegistrationId);
      // Sync with MixpanelService for tracking
      this._mixpanelService.setRegistrationId(storedRegistrationId);
    }
  }
}
